module.exports = __webpack_public_path__ + "Flag-344.e9e4569b8e6801e079bbbc699eed5d7f.svg";